import useAllExperiments from './useAllExperiments';
import { ExperimentValue } from '../types';

/**
 * Return value for single experiment
 * @param key
 */
const useExperiment = (key: string): ExperimentValue => {
  const experiments = useAllExperiments();
  return experiments[key] ?? false;
};

export default useExperiment;
